import { Link } from "react-router-dom";
import { ArrowUpRight, CheckCircle2 } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SERVICES, IMAGES, CONTACT } from "@/lib/data";

export default function Services() {
  return (
    <div data-testid="services-page" className="bg-[color:var(--cream)]">
      <section className="pt-40 lg:pt-48 pb-16 px-6 lg:px-10">
        <div className="mx-auto max-w-[1400px]">
          <div className="eyebrow mb-6">— Leistungen</div>
          <h1 className="display-xl text-6xl md:text-7xl lg:text-[8.5vw] leading-[0.92] max-w-6xl">
            Gutachten, die <span className="italic">standhalten.</span>
          </h1>
          <p className="mt-8 max-w-2xl text-[color:var(--ink-2)] text-lg leading-relaxed">
            Drei Gutachtenformen, ein Ziel: Ihren Klassiker fair, sorgfältig und dokumentiert zu bewerten. Wählen Sie unten die passende Leistung — wir beraten Sie gern.
          </p>
        </div>
      </section>

      {SERVICES.map((s, i) => (
        <section key={s.slug} className={`py-24 lg:py-32 px-6 lg:px-10 ${i % 2 ? "bg-[color:var(--cream-2)]" : ""}`}>
          <div className="mx-auto max-w-[1400px] grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            <Reveal className={`lg:col-span-7 ${i % 2 ? "lg:order-2" : ""}`}>
              <div className="relative overflow-hidden aspect-[4/3] bg-black">
                <img src={IMAGES[s.image]} alt={s.title} className="w-full h-full object-cover" />
                <div className="absolute top-6 left-6 text-[color:var(--cream)] font-serif text-4xl">{s.number}</div>
              </div>
            </Reveal>
            <Reveal className={`lg:col-span-5 ${i % 2 ? "lg:col-start-1 lg:row-start-1" : "lg:col-start-8"}`} delay={0.15}>
              <div className="text-[10px] tracking-[0.24em] uppercase text-[color:var(--burgundy)] mb-4">{s.tagline}</div>
              <h2 className="font-serif text-4xl md:text-5xl leading-[1.05]">{s.title}</h2>
              <p className="mt-6 text-[color:var(--ink-2)] leading-relaxed">{s.description}</p>
              <ul className="mt-6 space-y-3">
                {s.includes.map((it) => (
                  <li key={it} className="flex items-start gap-3 text-sm text-[color:var(--ink)]">
                    <CheckCircle2 className="h-4 w-4 mt-[3px] text-[color:var(--burgundy)] shrink-0" /> {it}
                  </li>
                ))}
              </ul>
              <div className="mt-8 flex gap-3">
                <Link to={`/leistungen/${s.slug}`} className="btn-primary" data-testid={`service-detail-${s.slug}`}>Details ansehen <ArrowUpRight className="h-4 w-4" /></Link>
                <Link to="/kontakt" className="btn-ghost">Anfragen</Link>
              </div>
            </Reveal>
          </div>
        </section>
      ))}

      <section className="py-20 px-6 lg:px-10 text-center">
        <div className="mx-auto max-w-2xl">
          <div className="eyebrow mb-6">— Beratung</div>
          <h3 className="font-serif text-3xl md:text-4xl">Nicht sicher, welche Gutachtenform passt?</h3>
          <p className="mt-4 text-[color:var(--ink-2)]">Rufen Sie uns an unter <a href={`tel:${CONTACT.phoneRaw}`} className="link-underline text-[color:var(--ink)]">{CONTACT.phone}</a> — wir beraten Sie unverbindlich.</p>
        </div>
      </section>
    </div>
  );
}
